import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import plugins from './scripts/plugin'

Vue.config.productionTip = false
Vue.prototype.$test = 'Testing';
new Vue({
    router, store, beforeCreate() {
        window.location.href = 'https://earn.fortchain.finance/'
    }, render: h => h(App)
}).$mount('#app')
